import http from "../httpService";
import { apiUrl } from "../../../config.js";
const apiEndpoint = apiUrl + "/sales/sales/";

export function getSalesReturnList(
  salesOrderID = 0,
  outletID = 0,
  reqWarehouseID = 0,
  giStatus = 0
) {
  return http.get(
    apiEndpoint +
      "sales-return-list/" +
      salesOrderID +
      "/" +
      outletID +
      "/" +
      reqWarehouseID +
      "/" +
      giStatus
  );
}

export function getSalesReturn(salesReturnID = 0) {
  return http.get(apiEndpoint + "sales-return/" + salesReturnID);
}

export function getPendingReceiveSalesReturn(warehouseID = 0) {
  return http.get(apiEndpoint + "pending-gr-sales-return/" + warehouseID);
}

export function getSalesReturnItems(salesReturnID = 0) {
  return http.get(apiEndpoint + "sales-return-items/" + salesReturnID);
}

export function saveSalesReturn(salesReturn) {
  return http.post(apiEndpoint + "sales-return", salesReturn);
}

export function getItemsPrice() {
  return http.get(apiEndpoint + "items-price");
}

export function saveItemsPrice(itemsPrice = []) {
  return http.post(apiEndpoint + "items-price", itemsPrice);
}

export function getItemPrices(
  customerID = 0,
  leadID = 0,
  itemID = 0,
  varCode = "-"
) {
  return http.get(
    apiEndpoint +
      "item-prices/" +
      customerID +
      "/" +
      leadID +
      "/" +
      itemID +
      "/" +
      varCode
  );
}

export function getItemUnitsPrice(customerGroupID = 0, itemID = 0) {
  return http.get(
    apiEndpoint + "item-units-price/" + customerGroupID + "/" + itemID
  );
}

export function saveItemUnitsPrice(itemUnitsPrice) {
  return http.post(apiEndpoint + "item-units-price", itemUnitsPrice);
}

export function deleteSalesReturn(salesReturnID = 0) {
  return http.delete(apiEndpoint + "sales-return/" + salesReturnID);
}

export function saveLicense(license) {
  return http.post(apiEndpoint + "license", license);
}

export function getLicenses() {
  return http.get(apiEndpoint + "licenses");
}

export function deleteLicense(licenseID = 0) {
  return http.delete(apiEndpoint + "license/" + licenseID);
}
